import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { Fragment } from 'react';

import { CUSTOMER_REVIEWS_MAX_STARS_RATE } from 'constants/store-editor';

import { ReactComponent as StarIcon } from 'assets/icons/star.svg';

import './ReviewStars.less';

const ReviewStars = ({ count = 1 }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="store-design-review-stars">
      <div className="store-design-review-stars__stars">
        {Array.from({ length: CUSTOMER_REVIEWS_MAX_STARS_RATE }).map(
          (_, index) => (
            <Fragment key={index}>
              <StarIcon
                className={classnames({
                  filled: index + 1 <= count
                })}
              />
            </Fragment>
          )
        )}
      </div>

      <span className="store-design-review-stars__stars-text">
        {formatMessage(
          {
            id: `store_design.reviews_section.${
              count > 1 ? 'stars_plural' : 'stars_singular'
            }`
          },
          {
            count
          }
        )}
      </span>
    </div>
  );
};

export default ReviewStars;
